import { SET_PARTNER_FIELD, SET_PARTNER } from './mutations';

const setPartnerField = ({ commit }, payload) => commit(SET_PARTNER_FIELD, payload);
const setPartner = ({ commit }, payload) => commit(SET_PARTNER, payload);

export default {
    setPartnerField,
    setPartner,
};
